/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenerateSOffenderRecordsReport200ResponseData } from './GenerateSOffenderRecordsReport200ResponseData';
import {
    GenerateSOffenderRecordsReport200ResponseDataFromJSON,
    GenerateSOffenderRecordsReport200ResponseDataFromJSONTyped,
    GenerateSOffenderRecordsReport200ResponseDataToJSON,
    GenerateSOffenderRecordsReport200ResponseDataToJSONTyped,
} from './GenerateSOffenderRecordsReport200ResponseData';

/**
 * 
 * @export
 * @interface GenerateSOffenderRecordsReport200Response
 */
export interface GenerateSOffenderRecordsReport200Response {
    /**
     * 
     */
    data?: GenerateSOffenderRecordsReport200ResponseData;
}

/**
 * Check if a given object implements the GenerateSOffenderRecordsReport200Response interface.
 */
export function instanceOfGenerateSOffenderRecordsReport200Response(value: object): value is GenerateSOffenderRecordsReport200Response {
    return true;
}

export function GenerateSOffenderRecordsReport200ResponseFromJSON(json: any): GenerateSOffenderRecordsReport200Response {
    return GenerateSOffenderRecordsReport200ResponseFromJSONTyped(json, false);
}

export function GenerateSOffenderRecordsReport200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateSOffenderRecordsReport200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : GenerateSOffenderRecordsReport200ResponseDataFromJSON(json['data']),
    };
}

export function GenerateSOffenderRecordsReport200ResponseToJSON(json: any): GenerateSOffenderRecordsReport200Response {
    return GenerateSOffenderRecordsReport200ResponseToJSONTyped(json, false);
}

export function GenerateSOffenderRecordsReport200ResponseToJSONTyped(value?: GenerateSOffenderRecordsReport200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': GenerateSOffenderRecordsReport200ResponseDataToJSON(value['data']),
    };
}

